// animatie voor de gravityforms


export function gravityForms() {

  // on init, add action if field is filled. 
  $(document).ready( function () {

    $('input[type=text]').each(function(){

      if (this.value) {
        $(this).parent().parent().find('label').addClass('active');
      }
    });
  });

  /** Code By Webdevtrick ( https://webdevtrick.com )  
   * Add /remove class on focus of the input field.
   * 
  **/
  $('input').on('focusin', function() {
    $(this).parent().parent().find('label').addClass('active');
  });
  
  $('input').on('focusout', function() {
    if (!this.value) {
      // console.log('out of focus');
      $(this).parent().parent().find('label').removeClass('active');
    }
  });
}